import { createAction } from "@ngrx/store";

export const ACTION_PREFIX = "[Registration With Address]";

export namespace AddressAction {
	export const getAddresses = createAction(`${ACTION_PREFIX} Get Addresses`);

	export const getAddressesSuccess = createAction(`${ACTION_PREFIX} Get Addresses Success`, (response: any) => ({
		response,
	}));

	export const getAddressesFail = createAction(`${ACTION_PREFIX} Get Addresses Fail`, (error: any) => ({
		error,
	}));
}
